import { cn } from '@moment/design-system-ui/lib/cn'

import { Text } from '#components/controls/text'

interface ResetSuccessMessageProps {
  className?: string
  showSuccess?: boolean
}

export const ResetSuccessMessage = ({
  className,
  showSuccess = false,
}: ResetSuccessMessageProps) => {
  if (!showSuccess) {
    return null
  }

  return (
    <div
      className={cn(
        'absolute top-0',
        'max-w-[340px] w-full',
        'p-3',
        'border  rounded-[0.625rem]',
        'bg-(--color-surface-primary) dark:bg-(--color-surface-secondary-contrast)/25',
        'border-(--color-border-primary) dark:border-(--color-border-primary-contrast)/40',
        'shadow-[0px_2px_8px_0px_rgba(0,0,0,0.03)] dark:shadow-[0px_2px_8px_0px_rgba(0,0,0,0.05)]',
        'text-(--color-text-secondary) dark:text-(--color-text-secondary-contrast)',
        className,
      )}
    >
      <Text
        variant="base"
        className={cn('text-center', '!leading-(--leading-lg)')}
        balance
      >
        Your password has been reset successfully. Please sign in with your new
        password.
      </Text>
    </div>
  )
}
